export const DROPDOWN_PORTAL_ID = 'nav-dropdown-portal';
